// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"428":"01a22525d00b6870","888":"0aaa61df7421c738"}[chunkId] + ".css";
};